'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _Types = require('../types/Types');

var _Types2 = _interopRequireDefault(_Types);

var _strip = require('../parcelData/strip');

var _strip2 = _interopRequireDefault(_strip);

var _ChangeRequest = require('../change/ChangeRequest');

var _ChangeRequest2 = _interopRequireDefault(_ChangeRequest);

var _ActionCreators = require('../change/ActionCreators');

var _ActionCreators2 = _interopRequireDefault(_ActionCreators);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_this) {
    return {

        // get methods

        raw: function raw() {
            return _this._parcelData;
        },

        data: function data() {
            return (0, _pipeWith2.default)(_this._parcelData, (0, _strip2.default)());
        },

        value: function value() {
            return _this._parcelData.value;
        },

        spread: function spread() {
            return {
                value: _this.value(),
                onChange: _this.onChange
            };
        },

        spreadDOM: function spreadDOM() {
            return {
                value: _this.value(),
                onChange: _this.onChangeDOM
            };
        },

        meta: function meta() {
            var meta = _this._parcelData.meta;

            return (0, _extends3.default)({}, meta);
        },

        hasDispatched: function hasDispatched() {
            return _this._treeshare.dispatch.hasPathDispatched(_this.path());
        },

        getInternalLocationShareData: function getInternalLocationShareData() {
            return _this._treeshare.locationShare.get(_this.path());
        },

        // change methods

        setSelf: function setSelf(value) {
            _this.dispatch(_ActionCreators2.default.setSelf(value));
        },

        updateSelf: function updateSelf(updater) {
            (0, _Types2.default)('updateSelf() expects param "updater" to be', 'function')(updater);
            _this.setSelf(updater(_this.value()));
        },

        onChange: function onChange(value) {
            _this.setSelf(value);
        },

        onChangeDOM: function onChangeDOM(event) {
            (0, _Types2.default)('onChangeDOM() expects param "event" to be', 'event')(event);
            _this.onChange(event.currentTarget.value);
        },

        setMeta: function setMeta(partialMeta) {
            (0, _Types2.default)('setMeta() expects param "partialMeta" to be', 'object')(partialMeta);
            _this.dispatch(_ActionCreators2.default.setMeta(partialMeta));
        },

        updateMeta: function updateMeta(updater) {
            (0, _Types2.default)('updateMeta() expects param "updater" to be', 'function')(updater);
            var meta = _this._parcelData.meta;

            (0, _pipeWith2.default)(meta, updater, (0, _Types2.default)('updateMeta() expects the result of updater() to be', 'object'), _this.setMeta);
        },

        setChangeRequestMeta: function setChangeRequestMeta(partialMeta) {
            (0, _Types2.default)('setChangeRequestMeta() expects param "partialMeta" to be', 'object')(partialMeta);
            _this.dispatch(new _ChangeRequest2.default().setMeta(partialMeta));
        },

        ping: function ping() {
            _this.dispatch(_ActionCreators2.default.ping());
        },

        // mutation methods

        setInternalLocationShareData: function setInternalLocationShareData(partialData) {
            (0, _Types2.default)('setInternalLocationShareData() expects param "partialData" to be', 'object')(partialData);
            _this._treeshare.locationShare.set(_this.path(), partialData);
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcel/ValueParcelMethods.js
// module id = 744
// module chunks = 35783957827783